import React from "react";
import { withRouter } from "react-router";
import TitleBar from "../../../components/common/title_bar";
import SearchFilter from "../../../components/filters/SearchFilter";
import FiscPendentes from "../../../components/ContaModule/FiscPendentes"
import * as $ from "jquery";
import services from '../../../services';
import { Select } from 'antd';
import queryString from "query-string";
import Swal from "sweetalert2";
import CurrencyInput from 'react-currency-input-field';

const { Option } = Select

var EntidadeSelected = null;
var DisableEntidadeSelect = false;

class FiscalizacaoCommon extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            //marcasPopup: "",
            applyedfilter: {},
            date: new Date(),
        };
    }

    componentDidMount() {
        (async () => {    

            var  dataToken = {"ValidaCC":true}
            var Detalhes = await services.apiCall.requestApi(
                "/Entidades/ViewEntidades",
                dataToken,
                "get"
            ); 
            
            var strHTML = "<option value='0' selected>Selecione...</option>";
            var NomeSubstring = "";

            Detalhes.map((value) => (

                value.nome.length > 40 ? NomeSubstring = $.trim(value.nome).substring(0, 40) + '...' : NomeSubstring = value.nome,

                strHTML = strHTML + "<option title='"+value.nome+"' value='" + value.identidade + "'>" + value.nif + "-"+ NomeSubstring + "</option>"

            ));
            
            // for (let index = 0; index < Detalhes.length; index++) {
            //     var nome = Detalhes[index].nome;
            //     var codEntidade = Detalhes[index].identidade
            //     var nif = Detalhes[index].nif;
            //     strHTML = strHTML + "<option value='" + codEntidade + "'>" + nif + "-"+ nome + "</option>";
            // }

            $("#entidades").html(strHTML)
            // if (Object.keys(this.props.row).length > 0) {
            //     $("#tipoVasilhas option[value='" + this.props.row.idTipoVasilha + "']").attr("selected","selected");
            // }
 
        })();
        
        this.createState();
        $(window).scrollTop(0);
    }

    componentDidUpdate(preProp) {
        if (preProp.date !== this.props.date) {
            $(window).scrollTop(0);
            this.createState();
        }
    }
    getFilters = (customfilters) => {
        let applyedfilter = { ...customfilters.filterCheckbox, ...customfilters.filters }
        delete applyedfilter.entity;
        applyedfilter.local = window.localStorage.getItem('Local');
        console.log("filter", applyedfilter);
        this.setState({
            applyedfilter,
            date:new Date()
        }, () => this.getEntityDetails(applyedfilter.entity_id)
        );
    }
	
	/*Para obter detalhes de uma única entidade usando api */

    getEntityDetails = async (entity_id) => {
        let Request = {};
        console.log("Entityfunction ", Request)
        this.setState({
            entity_details: {
                busEntidade: {},
                currentEntityBalance: 0,
                billingAddress: []
            }
        });
        if(!entity_id)
            return 
        Request.entityId = parseInt(entity_id);
        let link = "/Revenue/getEntityDetail"
        let res = await services.apiCall.requestApi(link, Request);
        if (res) {
            this.setState({
                entity_details: res
            });
        }
    }

    createState = () => {
        this.setState({
            entity_details: {},
            applyedfilter: {},
            //filters: this.props.linkData.filters,
        });
    };

    // getFilters = (customfilters) => {
    //     console.log("filter 800", customfilters.filters);
    //     const { filters } = customfilters;
    //     let applyedfilter = {};
    //     Object.keys(filters).map((item) => {
    //         if (item === "numeropedido") {
    //             applyedfilter["brandCode"] = +filters[item];
    //         } else if (item === "Nome de Marca") {
    //             applyedfilter["brandName"] = filters[item];
    //         } else if (item === "Numero de Entidade") {
    //             applyedfilter["entidadeNIF"] = +filters[item];
    //         } else if (item === "Nome de Entidade") {
    //             applyedfilter["entidadeName"] = filters[item];
    //         } else if (item === "Nº Processo") {
    //             applyedfilter["processNumber"] = +filters[item];
    //         }
    //     });
    //     delete applyedfilter.entity;
    //     applyedfilter.local = window.localStorage.getItem("Local");
    //     console.log("filter", applyedfilter);
    //     this.setState({
    //         applyedfilter,
    //         date: new Date(),
    //     });
    // };

    actionPerform = (action, row) => {
        //console.log("xxxxxxxxxxxxx=========>", action, row);
        // this.props.history.push({
        //     pathname: "/fiscalizacao",
        //     search: `?from=${window.location.pathname.substr(1)}&estado=${
        //         row.estado
        //     }&id=${row.idMarca}&tdp=Tipo de marca: ${
        //         row.tipoMarca
        //     }&evaluator=1&processo=${row.marca}`,
        // });
        
    };

    handleFilter = (data) => {
       // console.log("data in the common 800", data);
    };
    getIVDPEntidade= () => {
      if($("#Tipo :selected").val() == "2"){
        
        this.searchEntidade('INSTITUTO DOS VINHOS DO DOURO E PORTO');

        this.setState({defaultValueEntidade : 'INSTITUTO DOS VINHOS DO DOURO E PORTO'});
        EntidadeSelected = 19702;
        DisableEntidadeSelect = true;
        // $("#entidades option[value='19702']").attr("selected","selected")
        // $("#entidades").attr("disabled" , true)


      }else{ 

        this.setState({defaultValueEntidade : null});
        EntidadeSelected = null;
        DisableEntidadeSelect = false;

      }
    };

    AddNewSeloEtiqueta = () => {
        Swal.fire({
            title: 'Deseja confirmar o pedido?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Sim',
            denyButtonText: 'Não',
        }).then((result) => {
            if (result.isConfirmed) {
                (async () => {    

                    var  data = {
                        "etiquetaSelo":parseInt($('#Tipo').val()),
                        "idEntidade" : EntidadeSelected,
                        "letra": $('#Letra').val(),
                        "quantidade" : parseInt($('#Quantidade').val()),
                        "inicial": parseInt($('#Inicial').val()),
                        "loggedUser" : localStorage.username
                    }
        
                    var SelosEtiquetas = await services.apiCall.requestApi(
                        "/Fiscalizacao/InserirSelosEtiquetasSeguranca",
                        data,
                        "post"
                    ); 
        
                    if(SelosEtiquetas){
        
                        $('#id-cancel-selos-etiquetas').trigger('click');
        
                        //Clear Modal
                        $('#Tipo').val(0);
                        $('#entidades').val(0);
                        $('#Letra').val('');
                        $('#Quantidade').val(null);
                        $('#Inicial').val(null);
        
                    }
         
                })();
            } else if (result.isDenied) {
                //this.redirectScreen();
            }
        })
        

    }

    alphaOnly = (event) => {
        var key = event.keyCode;
        if((key >= 65 && key <= 90) || key == 8){
            $(event.currentTarget).val(event.key.toUpperCase());
        };
    };

    searchEntidade = (e) => {
        console.log("hey");
        console.log(e);
        let entidades = []
        const queryParams = queryString.parse(this.props.location.search)
        const token = +queryParams.idAuto

        if (e == ""){
          return;
        }
    
        const filters = {"Nome" : e , "NIF" : e};
        
        (async () => {
            if(this.props.location.search != ""){
                const filtersPreenchido = {"Nome" : e };
                    entidades = await services.apiCall.requestApi(
                        "/Entidades/ViewEntidadesFiscalizacao",
                        filtersPreenchido,
                        "get"
                    );
            }
            var Validanumero = /^\d+$/.test(e)
            if(Validanumero == false){
                const filters = {
                    "Nome" : e 
                };
                entidades = await services.apiCall.requestApi(
                    "/Entidades/ViewEntidadesFiscalizacao",
                    filters,
                    "get"
                );
            }else{
                const filters = {
                    "NIF" : e,
                };
                entidades = await services.apiCall.requestApi(
                    "/Entidades/ViewEntidadesFiscalizacao",
                    filters,
                    "get"
                );
            }
            
            this.setState({ entidades })

        })()
    }

    handleChangeEntidade = (e) => {

        EntidadeSelected = e
        this.setState({defaultValueEntidade : e});
    }

    render() {
        //console.log("Tablename", this.props.linkData.tableName);
        return (
            console.log("aqui"),
            window.location.pathname == "/FiscalizacaoInsercaoSelosEtiquetas" ? 
            <div className="inner-container">
                <div className="outer-space">
                    <TitleBar
                        onlyInicioLink={"/fiscalizacao"}
                        path={this.props.location.pathname}
                        title={this.props.linkData.TitleBartitle}
                        logo={"sivdp-icon sivdp-fiscalizacao"}
                        prevPageName={this.props.linkData.prevPageName}
                        prevPageLink={this.props.linkData.prevPageLink}
                        linkData={this.props.linkData}
                        noOption={true}
                        
                       optionMenuArray={this.props.optionMenuArray}
                    />
                   
                      
                    <SearchFilter 
                        optionText="Pesquisa por NIF ou Designação"
                        installationNumber={ true }
                        filters={ this.props.linkData.filters }
                        //-clickLimparFilter={this.state.clickLimparFilter}
                        searchplaceholder={ "Pesquisa por Nº de Instalação IVDP ou Designação" }
                        handleFilter={ (data) => this.handleFilter(data) }
                        getFilter={ (data) => this.getFilters(data) }
                        data={ this.state.data }
                        moduleType="FiscalizacaoInsercaoSelosEtiquetas"
                        
                    />
                    
                   <FiscPendentes
                        date={this.state.date}
                        tableName={this.props.linkData.tableName}
                        //actionPerform={this.ActionPerformMarcas}
                        applyedfilter={this.state.applyedfilter}
                    />
                    
                    <div className="modal left-popup" id="FiscalizacaoInsercaoSelosEtiquetas-popup">
                        <div className="modal-dialog modal-sm">
                            <div class="modal-content" style={{maxWidth: "533px"}}>
                                <div class="modal-header" style={{fontSize: "20px"}}>
                                    <h5 class="modal-title">Adicionar Selos/Etiquetas</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <form id="id-form-new-fiscalizacao-selos-etiquetas">
                                    <div className="col-md-12">
                                            <div className="input-box active-grey drop-down-box">
                                                <label className="input-label">Tipo</label>
                                                <select class='custome-drop-down Tipo' name='Tipo' id="Tipo" onChange={this.getIVDPEntidade}>
                                                        <option value='0' selected disabled>Selecione...</option>
                                                        <option value='1'>Selo</option>
                                                        <option value='2'>Etiqueta</option>
                                                </select>
                                            </div>
                                    </div>
                                        <div className="col-md-12">


                                            <div className="input-box active-grey drop-down-box" >
                                                     <label className="input-label label-entidade-new-seloetiqueta">Entidades</label> 

                                                    <div className="App container" style={{padding:"0px"}}>

                                                        {/* aqui */}
                                                        <Select
                                                            showSearch
                                                            onSearch={(e) => this.searchEntidade(e)}
                                                            onChange={(e) => this.handleChangeEntidade(e)}
                                                            disabled ={DisableEntidadeSelect}
                                                            defaultValue={this.state.defaultValueEntidade}
                                                            value={this.state.defaultValueEntidade}
                                                            optionFilterProp="children"
                                                            className="mov-Ent-Select DropEntidade"                                                            
                                                            style={{ width: "100%"}}>
                                                            
                                                            
                                                            <Option disabled >Selecione a entidade destino</Option>
                                                            {(this.state.entidades && !!this.state.entidades.length) && this.state.entidades.map((item, index) => (
                                                                <Option key={index} value={item.codEntidade}>{item.nome + " - " + item.nif} </Option>
                                                            ))}
                                                        </Select>
                                                    </div>

                                            </div>



                                            {/* <div className="input-box active-grey drop-down-box">
                                                <label className="input-label" style={{zIndex: "1"}}>Entidades</label>
                                                <select class='custome-drop-down entidades selectpicker' name='entidades' id="entidades" data-live-search="true" >
                                                        <option title="Selecione" value='0' selected disabled>Selecione...</option>
                                                </select>
                                            </div> */}
                                        </div>
                                        
                                        <div className="col-md-12">
                                            <div className="input-box active-grey drop-down-box">
                                                <label className="input-label">
                                                    Letra
                                                </label>
                                                <input type="text" class="input-1 Letra blockSpecialChar" name="letra" id="Letra" maxlength="1" onKeyDown={this.alphaOnly}/>
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="input-box active-grey drop-down-box">
                                                <label className="input-label">
                                                    Quantidade
                                                </label>
                                                {/* <input type="number" class="input-1 Quantidade blockSpecialChar" name="quantidade" id="Quantidade"/> */}
                                                <CurrencyInput
                                                    id='Quantidade'
                                                    name="quantidade"
                                                    defaultValue={0.000}
                                                    decimalSeparator="," 
                                                    groupSeparator="."
                                                    maxLength={8}
                                                    precision="3"
                                                    className="input-1 Quantidade blockSpecialChar"
                                                    // intlConfig={{ style: 'currency' ,locale: 'pt-PT', currency: 'EUR' }}
                                                    onValueChange={(value, name) => console.log(value, name)}
                                                    onChange={this.handleChange} 
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="input-box active-grey drop-down-box">
                                                <label className="input-label">
                                                    Inicial
                                                </label>
                                                {/* <input type="number" class="input-1 Inicial blockSpecialChar" name="inicial" id="Inicial"/> */}
                                                <CurrencyInput
                                                    id='Inicial'
                                                    name="inicial"
                                                    defaultValue={0.000}
                                                    decimalSeparator="," 
                                                    groupSeparator="."
                                                    maxLength={8}
                                                    precision="3"
                                                    className="input-1 Inicial blockSpecialChar"
                                                    // intlConfig={{ style: 'currency' ,locale: 'pt-PT', currency: 'EUR' }}
                                                    onValueChange={(value, name) => console.log(value, name)}
                                                    onChange={this.handleChange} 
                                                />
                                            </div>
                                        </div>

                                    </form>
                                </div>
                                <div class="modal-footer">
                                    <button id="id-add-new-selos-etiquetas" type="button" class="btn btn-primary" style={{backgroundColor: "#960030" , border: "1px solid #960030"}} onClick={this.AddNewSeloEtiqueta}>Adicionar</button>
                                    <button id="id-cancel-selos-etiquetas" type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            :
            <div className="inner-container">
                <div className="outer-space">
                    <TitleBar
                        onlyInicioLink={"/fiscalizacao"}
                        path={this.props.location.pathname}
                        title={this.props.linkData.TitleBartitle}
                        logo={"sivdp-icon sivdp-fiscalizacao"}
                        prevPageName={this.props.linkData.prevPageName}
                        prevPageLink={this.props.linkData.prevPageLink}
                        linkData={this.props.linkData}
                        noOption={true}
                        
                       optionMenuArray={this.props.optionMenuArray}
                    />
                   
                   <FiscPendentes
                        date={this.state.date}
                        tableName={this.props.linkData.tableName}
                        //actionPerform={this.ActionPerformMarcas}
                        applyedfilter={this.state.applyedfilter}
                    />
                </div>
            </div>
        );
        
    }
}

export default withRouter(FiscalizacaoCommon);
